import { AxiosResponse } from 'axios';

const apiVersionResponseInterceptors = async function (config: AxiosResponse) {
   const xApiVersion = config?.headers?.['x-api-version'];

   if (xApiVersion) {
      checkApiVersion(xApiVersion);
   }

   return config;
};

function checkApiVersion(newApiVersion: string) {
   const oldApiVersion = localStorage.getItem('api-version');

   if (oldApiVersion !== newApiVersion) {
      localStorage.setItem('api-version', newApiVersion);
      caches.delete('nxt-plan-api-cache-force');
   }
}

export { apiVersionResponseInterceptors };
